import React, { useState } from 'react';
import { Header } from 'semantic-ui-react';
import { defineMessages, injectIntl } from 'react-intl';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { compose } from 'redux';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import { toBackendLang } from '@plone/volto/helpers/Utils/Utils';
import { connect } from 'react-redux';

import leftKey from '@plone/volto/icons/left-key.svg';
import rightKey from '@plone/volto/icons/right-key.svg';
import clearSVG from '@plone/volto/icons/clear.svg';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const messages = defineMessages({
  startDate: { id: 'Start Date', defaultMessage: 'Start Date' },
  endDate: { id: 'End Date', defaultMessage: 'End Date' },
  year: { id: 'Year', defaultMessage: 'Year' },
});

const PrevIcon = () => (
  <div
    className="prev-icon"
    style={{ color: '#000', left: '22px', padding: '5px', position: 'absolute', top: '15px' }}
    tabIndex="0"
  >
    <Icon name={leftKey} size="30px" />
  </div>
);

const NextIcon = () => (
  <div
    className="next-icon"
    style={{ color: '#000', right: '22px', padding: '5px', position: 'absolute', top: '15px' }}
    tabIndex="0"
  >
    <Icon name={rightKey} size="30px" />
  </div>
);

const CloseIcon = () => <Icon name={clearSVG} size="24px" className="close" />;

const DateRangeFacet = (props) => {
  const { facet, isEditMode, onChange, value, reactDates, intl, lang } = props;
  const moment = props.moment.default;
  const [focused, setFocused] = useState(null);
  const [selectedYear, setSelectedYear] = useState(
    value && value[0] ? moment(value[0]).year() : moment().year()
  );

  // Handle year change
  const handleYearChange = (date) => {
    const year = date.getFullYear();
    setSelectedYear(year);
    onChange(facet.field.value, [`${year}-01-01`, `${year}-12-31`]);
  };

  return (
    <div className="daterange-facet">
      <Header as="h4">{facet?.title ?? facet?.field?.label}</Header>

      {/* Year Picker */}
      <div className="ui form date-time-widget-wrapper">
        <Header as="h5">{intl.formatMessage(messages.year)}</Header>
        <DatePicker
          selected={new Date(selectedYear, 0, 1)}
          onChange={handleYearChange}
          showYearPicker
          dateFormat="yyyy"
        />
      </div>

      {/* Optional: still allow manual date range */}
      <div className="ui form date-time-widget-wrapper">
        <div className="ui input date-input">
          <DateRangePicker
            startDate={value && value[0] ? moment(value[0]) : null}
            startDateId={`${facet['@id']}-start-date`}
            startDatePlaceholderText={intl.formatMessage(messages.startDate)}
            endDate={value && value[1] ? moment(value[1]) : null}
            endDateId={`${facet['@id']}-end-date`}
            endDatePlaceholderText={intl.formatMessage(messages.endDate)}
            numberOfMonths={1}
            disabled={isEditMode}
            noBorder
            showClearDates
            customCloseIcon={<CloseIcon />}
            displayFormat={moment.localeData(toBackendLang(lang)).longDateFormat('L')}
            focusedInput={focused}
            onFocusChange={(focusedInput) => setFocused(focusedInput)}
            onDatesChange={({ startDate, endDate }) => {
              onChange(facet.field.value, [
                startDate ? startDate.format('DD-MM-YYYY') : null,
                endDate ? endDate.format('DD-MM-YYYY') : null,
              ]);
            }}
            isOutsideRange={() => false}
            navPrev={<PrevIcon />}
            navNext={<NextIcon />}
          />
        </div>
      </div>
    </div>
  );
};

// Make sure these are outside the component
DateRangeFacet.stateToValue = ({ selectedValue }) => {
  if (!selectedValue || selectedValue.length !== 2) {
    const currentYear = new Date().getFullYear();
    return [`${currentYear}-01-01`, `${currentYear}-12-31`];
  }
  return selectedValue;
};

DateRangeFacet.valueToQuery = ({ value, facet }) =>
  value && typeof value[0] === 'string' && typeof value[1] === 'string'
    ? {
        i: facet.field.value,
        o: 'plone.app.querystring.operation.date.between',
        v: value,
      }
    : null;

export default compose(
  injectLazyLibs(['reactDates', 'moment']),
  connect((state) => ({ lang: state.intl.locale })),
  injectIntl,
)(DateRangeFacet);
